import { Component, OnInit } from '@angular/core';
import { RequestsMetricsService } from '../../service/requests-metrics.service';
import { ErrorHandlerService } from '../../../services/shared/error-handler.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AccountsService } from '../../../services/settings-service/accounts/accounts.service';

@Component({
  selector: 'app-requests-metrics',
  templateUrl: './requests-metrics.component.html',
  styleUrls: ['./requests-metrics.component.css']
})
export class RequestsMetricsComponent implements OnInit {
  statistics: any;
  topEndPoints: any;
  topEndpointsTableTitle = 'High-traffic endpoints';
  topEndPointsHeaders: any = [
    'Method',
    'Endpoint',
    'Requests',
    'Ava. Response Time',
    'Max. Response Time',
    'Ava. DB Response Time',
    'Errors'
  ];
  topEndPointsBody: any = [
    {
      key: 'method',
      type: 'string'
    },
    {
      key: 'endpoint',
      type: 'string'
    },
    {
      key: 'requests_count',
      type: 'string'
    },
    {
      key: 'avg_duration_ms',
      type: 'seconds'
    },
    {
      key: 'max_duration_ms',
      type: 'seconds'
    },
    {
      key: 'avg_db_time_ms',
      type: 'seconds'
    },
    {
      key: 'error_count',
      type: 'string'
    },
  ];
  
  endPointsInRange: any;
  endpointsInRangeTableTitle = 'All Endpoints In The Range';
  endPointsInRangeHeaders: any = [
    'Method',
    'Endpoint',
    'Requests',
    'Ava. Response Time',
    'Max. Response Time',
    'Ava. DB Response Time',
    'Errors'
  ];
  endPointsInRangeBody: any = [
    {
      key: 'method',
      type: 'string'
    },
    {
      key: 'endpoint',
      type: 'string'
    },
    {
      key: 'requests_count',
      type: 'string'
    },
    {
      key: 'avg_duration_ms',
      type: 'seconds'
    },
    {
      key: 'max_duration_ms',
      type: 'seconds'
    },
    {
      key: 'avg_db_time_ms',
      type: 'seconds'
    },
    {
      key: 'error_count',
      type: 'string'
    },
  ];

  slowestEndPointsOnAverage: any;
  slowestEndPointsOnAverageTableTitle = 'Slowest Endpoints (On Average)';
  slowestEndPointsOnAverageHeaders: any = [
    'Method',
    'Endpoint',
    'Ava. Response Time',
    'Max. Response Time',
    'Requests',
  ];
  slowestEndPointsOnAverageBody: any = [
    {
      key: 'method',
      type: 'string'
    },
    {
      key: 'endpoint',
      type: 'string'
    },
    {
      key: 'avg_duration_ms',
      type: 'seconds'
    },
    {
      key: 'max_duration_ms',
      type: 'seconds'
    },
    {
      key: 'requests_count',
      type: 'string'
    },
  ];

  dbHeavyEndpoints: any;
  dbHeavyEndpointsTableTitle = 'Database-heavy endpoints';
  dbHeavyEndpointsHeaders: any = [
    'Method',
    'Endpoint',
    'Avg. DB Response Time',
    'Max. DB Response Time',
    'Avg. DB Queries',
    'Requests'
  ];
  dbHeavyEndpointsBody: any = [
    { key: 'method', type: 'string' },
    { key: ['endpoint', 'path'], type: 'string' },
    { key: ['avg_db_time_ms', 'db_time_ms'], type: 'seconds' },
    { key: 'max_db_time_ms', type: 'seconds' },
    { key: ['avg_db_queries', 'avg_db_query_count'], type: 'number' },
    { key: ['requests_count', 'request_count'], type: 'number' }
  ];

  topUsers: any;
  topUsersTableTitle = 'Top users';
  topUsersHeaders: any = [
    'User',
    'Email',
    'Requests',
    'Avg. Response Time',
    'Errors'
  ];
  topUsersBody: any = [
    { key: ['user_name', 'name', 'user.name'], type: 'string' },
    { key: ['email', 'user.email'], type: 'string' },
    { key: ['requests_count', 'request_count'], type: 'number' },
    { key: ['avg_duration_ms', 'duration_ms'], type: 'seconds' },
    { key: ['error_count', 'errors_count'], type: 'number' }
  ];

  recentSlowRequests: any;
  recentSlowRequestsTableTitle = 'Recent slow requests';
  recentSlowRequestsHeaders: any = [
    'User',
    'Method',
    'Endpoint',
    'Status',
    'Response Time',
    'DB Time',
    'Date'
  ];
  recentSlowRequestsBody: any = [
    { key: ['user_name', 'name', 'user.name'], type: 'string' },
    { key: 'method', type: 'string' },
    { key: ['endpoint', 'path'], type: 'string' },
    { key: ['status_code', 'status'], type: 'string' },
    { key: ['duration_ms', 'response_time_ms'], type: 'seconds' },
    { key: 'db_time_ms', type: 'seconds' },
    { key: ['created_at', 'date'], type: 'date' }
  ];

  recentErrors: any;
  recentErrorsTableTitle = 'Recent errors';
  recentErrorsHeaders: any = [
    'User',
    'Method',
    'Endpoint',
    'Status',
    'Response Time',
    'Error',
    'Date'
  ];
  recentErrorsBody: any = [
    { key: ['user_name', 'name', 'user.name'], type: 'string' },
    { key: 'method', type: 'string' },
    { key: ['endpoint', 'path'], type: 'string' },
    { key: ['status_code', 'status'], type: 'string' },
    { key: ['duration_ms', 'response_time_ms'], type: 'seconds' },
    { key: ['error_message', 'exception_message', 'message'], type: 'string' },
    { key: ['created_at', 'date'], type: 'date' }
  ];

  activity: any;
  activityTableTitle = 'Request activity';
  activityHeaders: any = [
    'User',
    'Method',
    'Endpoint',
    'Status',
    'Response Time',
    'DB Time',
    'DB Queries',
    'Date'
  ];
  activityBody: any = [
    { key: ['user_name', 'name', 'user.name'], type: 'string' },
    { key: 'method', type: 'string' },
    { key: ['endpoint', 'path'], type: 'string' },
    { key: ['status_code', 'status'], type: 'string' },
    { key: ['duration_ms', 'response_time_ms'], type: 'seconds' },
    { key: 'db_time_ms', type: 'seconds' },
    { key: ['db_query_count', 'query_count'], type: 'number' },
    { key: ['created_at', 'date'], type: 'date' }
  ];

  filterForm: FormGroup;
  users: any[];
  statuses: any[] = [
    {
      label: '200',
      value: '200'
    },
    {
      label: '201',
      value: '201'
    },
    {
      label: '400',
      value: '400'
    },
    {
      label: '401',
      value: '401'
    },
    {
      label: '403',
      value: '403'
    },
    {
      label: '404',
      value: '404'
    },
    {
      label: '500',
      value: '500'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private accountsService: AccountsService,
    private errorHandlerService: ErrorHandlerService,
    private requestsMetricsService: RequestsMetricsService
  ) { }

  ngOnInit() {
    this.initalizeFilterForm();
    this.getUsers();
    this.initData();
  }

  initalizeFilterForm() {
    this.filterForm = this.fb.group({
      date_from: [null],
      date_to: [null],
      user_id: [null],
      endpoint: [null],
      status_code: [null],
      only_slow: [null],
      only_errors: [null],
      //not used
      // method: [null],
      // endpoint_like: [null],
      // path: [null],
      // route_name: [null],
      // ip: [null],
      // min_duration_ms: [null],
      // max_duration_ms: [null],
      // min_db_time_ms: [null],
      // max_db_time_ms: [null],
      // min_db_query_count: [null],
      // per_page: [null],
      // page: [null],
      // sort_by: [null],
      // sort_direction: [null]
    });
  }

  initData() {
    const params = this.filterForm.value;
    this.getEndpoints(params);
    this.getStatistics(params);
    this.getTopEndpoints(params);
    this.getSlowestEndpoints(params);
    this.getDbHeavyEndpoints(params);
    this.getTopUsers(params);
    this.getRecentSlowRequests(params);
    this.getRecentErrors(params);
    this.getActivity(params);
  }

  resetFilters() {
    this.filterForm.reset();
    this.initData();
  }

  convertMillisecondsToSeconds(ms: number) {
    const seconds = ms / 1000;
    return seconds.toFixed(2);
  }

  getUsers() {
    this.accountsService.getAccounts().subscribe(
      (res) => {
        this.users = res.data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getStatistics(params: any) {
    this.requestsMetricsService.getStatistics(params)
      .subscribe({
        next: (res: any) => {
          this.statistics = res.data;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  getTopEndpoints(params: any) {
    this.requestsMetricsService.getTopEndpoints(params)
      .subscribe({
        next: (res: any) => {
          this.topEndPoints = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPervTopEndpoints() {
    this.requestsMetricsService.infinte(this.topEndPoints.links.prev).subscribe({
      next: (data) => {
        this.topEndPoints = data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  goToNextTopEndpoints() {
    this.requestsMetricsService.infinte(this.topEndPoints.links.next).subscribe({
      next: (data) => {
        this.topEndPoints = data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  getEndpoints(params: any) {
    this.requestsMetricsService.getEndpoints(params)
      .subscribe({
        next: (res: any) => {
          this.endPointsInRange = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPervEndpoints() {
    this.requestsMetricsService.infinte(this.endPointsInRange.links.prev).subscribe({
      next: (data) => {
        this.endPointsInRange = data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  goToNextEndpoints() {
    this.requestsMetricsService.infinte(this.endPointsInRange.links.next).subscribe({
      next: (data) => {
        this.endPointsInRange = data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }
  
  getSlowestEndpoints(params: any) {
    this.requestsMetricsService.getSlowestEndpoints(params)
      .subscribe({
        next: (res: any) => {
          this.slowestEndPointsOnAverage = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPervSlowestEndpoints() {
    this.requestsMetricsService.infinte(this.slowestEndPointsOnAverage.links.prev).subscribe({
      next: (data) => {
        this.slowestEndPointsOnAverage = data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  goToNextSlowestEndpoints() {
    this.requestsMetricsService.infinte(this.slowestEndPointsOnAverage.links.next).subscribe({
      next: (data) => {
        this.slowestEndPointsOnAverage = data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  getDbHeavyEndpoints(params: any) {
    this.requestsMetricsService.getDbHeavyEndpoints(params)
      .subscribe({
        next: (res: any) => {
          this.dbHeavyEndpoints = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPreviousDbHeavyEndpoints() {
    this.loadPage(
      this.getPageLink(this.dbHeavyEndpoints, 'prev'),
      (data) => this.dbHeavyEndpoints = data
    );
  }

  goToNextDbHeavyEndpoints() {
    this.loadPage(
      this.getPageLink(this.dbHeavyEndpoints, 'next'),
      (data) => this.dbHeavyEndpoints = data
    );
  }

  getTopUsers(params: any) {
    this.requestsMetricsService.getTopUsers(params)
      .subscribe({
        next: (res: any) => {
          this.topUsers = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPreviousTopUsers() {
    this.loadPage(
      this.getPageLink(this.topUsers, 'prev'),
      (data) => this.topUsers = data
    );
  }

  goToNextTopUsers() {
    this.loadPage(
      this.getPageLink(this.topUsers, 'next'),
      (data) => this.topUsers = data
    );
  }

  getRecentSlowRequests(params: any) {
    this.requestsMetricsService.getRecentSlowRequests(params)
      .subscribe({
        next: (res: any) => {
          this.recentSlowRequests = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPreviousRecentSlowRequests() {
    this.loadPage(
      this.getPageLink(this.recentSlowRequests, 'prev'),
      (data) => this.recentSlowRequests = data
    );
  }

  goToNextRecentSlowRequests() {
    this.loadPage(
      this.getPageLink(this.recentSlowRequests, 'next'),
      (data) => this.recentSlowRequests = data
    );
  }

  getRecentErrors(params: any) {
    this.requestsMetricsService.getRecentErrors(params)
      .subscribe({
        next: (res: any) => {
          this.recentErrors = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPreviousRecentErrors() {
    this.loadPage(
      this.getPageLink(this.recentErrors, 'prev'),
      (data) => this.recentErrors = data
    );
  }

  goToNextRecentErrors() {
    this.loadPage(
      this.getPageLink(this.recentErrors, 'next'),
      (data) => this.recentErrors = data
    );
  }

  getActivity(params: any) {
    this.requestsMetricsService.getActivity(params)
      .subscribe({
        next: (res: any) => {
          this.activity = res;
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        }
      });
  }

  goToPreviousActivity() {
    this.loadPage(
      this.getPageLink(this.activity, 'prev'),
      (data) => this.activity = data
    );
  }

  goToNextActivity() {
    this.loadPage(
      this.getPageLink(this.activity, 'next'),
      (data) => this.activity = data
    );
  }

  private loadPage(url: string | null | undefined, update: (data: any) => void) {
    if (!url) {
      return;
    }

    this.requestsMetricsService.infinte(url).subscribe({
      next: update,
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      }
    });
  }

  private getPageLink(tableData: any, direction: string): string {
    return tableData && tableData.links ? tableData.links[direction] : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/components/requests-metrics/requests-metrics.component.ts